const IconCorner = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 20.8167C0 22.5748 1.43292 24.0222 3.17586 23.7917C13.8906 22.3753 22.3753 13.8906 23.7917 3.17586C24.0222 1.43291 22.5748 0 20.8167 0L3.18333 0C1.42523 0 0 1.42523 0 3.18333L0 20.8167Z"
      fill="#1F8475"
    />
  </svg>
);

export default IconCorner;
